<script setup lang="ts">
  // Workspace
  import type { Sms, SMSThread } from '@stuut/api-sdk/models';
  import { Sheet, SheetContent } from '@ui/components/sheet';

  import { SMSView } from '@/components/sms';

  defineProps<{
    thread?: SMSThread | null;
    draftSms?: Sms | null;
  }>();

  const emits = defineEmits<{
    (e: 'close'): void;
    (e: 'sent'): void;
  }>();
</script>

<template>
  <Sheet v-bind="$attrs">
    <SheetContent
      side="right"
      floating
      close-position="right"
      class="lg:!min-w-[60vw] lg:!max-w-[80vw] pt-2"
      prevent-launcher
      default-open
      style="width: calc(100% - 1rem)"
      :disable-dismiss-on="['interact-outside']"
      @close="emits('close')"
      @close-auto-focus="
        (e) => {
          e.preventDefault();
        }
      "
    >
      <SMSView
        v-if="thread"
        :thread
        :draft-sms="draftSms"
        @close="emits('close')"
        @sent="emits('sent')"
      />
    </SheetContent>
  </Sheet>
</template>

<style scoped></style>
